// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_BASE_URL: 'https://nftbscapi.seekware.tech/v1/',
  IMG_BASE_URL: 'https://nftbscapi.seekware.tech/v1/',
  BUSD_CONTRACT_ADDRESS: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
  PLATFORM_OWNER_ADDRESS: '0x631822399789E4BcFa1EfF1dffBf07cb99441FDC',
  ETH_PRIVATE_KEY:
    '13f4b7fb02db9b133aeac585e6e068e9dc53ff6b9da34922ca61ec291768f2c5',
  ETH_PUBLIC_KEY: '0x631822399789E4BcFa1EfF1dffBf07cb99441FDC',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
